/* Option "Bracelet Signature +20€" sur les fiches montres AP x Swatch.
   Même principe que le flocage maillots : case à cocher -> ajoute la montre + le bracelet au panier.
   Bracelet Signature — Collection AP x Swatch, variant "Taille unique" 20,00€. */
(function () {
  var BRACELET_VARIANT_ID = 57797465833820;

  function getHandle() {
    var m = location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : '';
  }

  function injectStyle() {
    if (document.getElementById('bracelet-upsell-style')) return;
    var s = document.createElement('style');
    s.id = 'bracelet-upsell-style';
    s.textContent =
      '.bracelet-upsell{margin:4px 0 0;padding:14px 16px;border:1.5px solid #e0e0e0;border-radius:8px;background:#fafafa}' +
      '.bracelet-upsell__toggle{display:flex;align-items:center;gap:10px;cursor:pointer;font-size:.95rem;font-weight:500;margin:0}' +
      '.bracelet-upsell__toggle input{width:18px;height:18px;cursor:pointer;accent-color:#0d0d0d;flex-shrink:0}';
    document.head.appendChild(s);
  }

  function init() {
    var handle = getHandle();
    // Cible uniquement les montres AP x Swatch (leurs handles commencent par "swatch-x-audemars-piguet")
    if (handle.indexOf('swatch-x-audemars-piguet') !== 0) return;

    var form = document.querySelector('form[data-product-form]');
    if (!form) return;
    var purchase = form.querySelector('.product-form__purchase');
    if (!purchase || document.getElementById('bracelet-block')) return;

    injectStyle();

    var wrap = document.createElement('div');
    wrap.className = 'bracelet-upsell';
    wrap.id = 'bracelet-block';
    wrap.innerHTML =
      '<label class="bracelet-upsell__toggle">' +
      '<input type="checkbox" id="bracelet-checkbox">' +
      '<span>Ajouter le <strong>bracelet signature</strong> assorti <strong>+20,00€</strong></span>' +
      '</label>';
    purchase.parentNode.insertBefore(wrap, purchase);

    var atcBtn = form.querySelector('[data-atc-button]') || form.querySelector('[name="add"]');
    if (!atcBtn) return;

    atcBtn.addEventListener('click', async function (e) {
      var cb = document.getElementById('bracelet-checkbox');
      if (!cb || !cb.checked) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var idInput = form.querySelector('[name="id"]');
      var mainId = idInput ? idInput.value : null;
      if (!mainId) return;

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: mainId, quantity: 1 },
              { id: BRACELET_VARIANT_ID, quantity: 1 }
            ]
          })
        });
        if (!res.ok) {
          var err = await res.json().catch(function () { return null; });
          alert('Erreur lors de l\'ajout au panier' + (err && err.description ? ' : ' + err.description : ''));
          return;
        }
      } catch (e2) {
        alert('Erreur réseau lors de l\'ajout au panier.');
        return;
      }

      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer();
      } else {
        window.location.href = '/cart';
      }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
